<template>
  <div class="block">
    <div class="header">
      <div>{{ $t('Gamification_CompetitionDetails') }}</div>
      <div class="description">
        <span>{{ $t('Gamification_CompetitionDetailsDescription') }}</span>
      </div>
    </div>
    <div class="content">
      <div class="section" data-qa="bracket-builder-info">
        <div>
          <span>{{ $t('Gamification_BracketBuilder_Label') }}</span
          ><br />
          <span class="description">{{
            $t('Gamification_BracketBuilder_Description')
          }}</span>
        </div>
        <div class="value">
          {{ getBracketBuilderText(model.manual_bracket) }}
        </div>
      </div>
      <div class="section">
        <div>
          <span>{{
            $t('Gamification_GameCompetitionTeamsForm_SportType')
          }}</span
          ><br />
          <span class="description">{{
            $t('Gamification_GameCompetitionTeamsForm_ChooseSportDescription')
          }}</span>
        </div>
        <div class="value">{{ model.sport_name }}</div>
      </div>
      <div class="section">
        <div>
          <span>{{ $t('Gamification_GameCompetitionTeamsForm_Location') }}</span
          ><br />
          <span class="description">{{
            $t('Gamification_GameCompetitionTeamsForm_ChooseCountryDescription')
          }}</span>
        </div>
        <div class="value">{{ model.country_name }}</div>
      </div>
      <div class="section">
        <div>
          <span>{{
            $t('Gamification_GameCompetitionTeamsForm_Competition')
          }}</span
          ><br />
          <span class="description">{{
            $t(
              'Gamification_GameCompetitionTeamsForm_CompetitionSelectionDescription'
            )
          }}</span>
        </div>
        <div class="value">{{ model.competition_name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GameCompetitionDetailsTable',
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  methods: {
    getBracketBuilderText(payload) {
      if (!payload) return this.$t('Gamification_ManualBracket_Off')

      return this.$t('Gamification_ManualBracket_On')
    }
  }
}
</script>
<style scoped>
.block {
  font-size: 14px;
  font-weight: 600;
  color: #4b515f;
  border: 1px solid #dbdee7;
  background-color: #fcfcfd;
  border-radius: 4px;
}
.description {
  font-size: 12px;
  font-weight: 400;
  color: #5c6374;
}

.value {
  font-weight: 400;
}

.header {
  padding: 10px 24px;
}

.content {
  border-top: 1px solid #dbdee7;
  padding: 10px 24px;
  gap: 25px;
  display: flex;
  flex-direction: column;
}

.section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 80%;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-campaigns/setup/bracketPredictor/GameCompetitionDetailsTable.vue